<template>
  <div class="option">
    <div class="option__key">
      <IconText
        :icon="icon"
        :text="label + ':'"
      />
    </div>
    <div class="option__value">
      <span
        v-if="showAdditional"
        class="option__value-show"
        @click="onMore"
      >
        {{ showAdditionalText }}
      </span>

      <a v-if="valueHref" :href="valueHref">{{ value }}</a>
      <span v-else>{{ value }}</span>
    </div>
  </div>
</template>

<script>
import IconText from '@/components/IconText'

export default {
  name: 'AppDescriptionItem',
  components: {
    IconText
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    valueHref: {
      type: String,
      default: ''
    },
    showAdditional: {
      type: Boolean,
      default: false
    },
    showAdditionalText: {
      type: String,
      default: ''
    }
  },
  emits: {
    more: null
  },
  methods: {
    onMore () {
      this.$emit('more')
    }
  }
}
</script>

<style lang="scss" scoped>
$brand-color:                 #FF7A00 !default;

.option {
  font-size: 18px;
  color: #C6C6CE;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 0;
  border-bottom: 1.5px solid rgba(198, 198, 206, 0.1);

  &__key {
    width: 50%;
  }
  &__value {
    width: 50%;
    text-align: right;

    a {
      color: inherit;
    }

    &-show {
      padding-right: 10px;
      color: $brand-color;
      cursor: pointer;
    }
  }
}
</style>
